// @flow
import type { Member } from '../../models/group_chats/Member';

export class Mention {
  id: string;
  type: string;
  name: string;

  constructor(id: string, type: string, name: string) {
    this.id = id;
    this.type = type;
    this.name = name;
  }

  render() {
    return (
      `<span mention="${this.textContent}" ` +
      `id="${this.id + ''}" ` +
      `data-type="${this.type}" ` +
      'class="mention"' +
      `>${this.textContent}</span>`
    );
  }

  get textContent() {
    return `TO ${this.name}`;
  }

  static from(member: Member): Mention {
    return new Mention(
      member.id + '',
      member.type ? member.type : '',
      member.name,
    );
  }
}

export class AttachmentMention extends Mention {
  render() {
    return (
      `<p><span mention="${this.name}" ` +
      `id="${this.id + ''}" ` +
      `data-type="${this.type}" ` +
      'class="attachment"' +
      `>${this.name}</span></p>`
    );
  }

  static from(attachment: any) {
    return new AttachmentMention('fileid', 'file', attachment.name);
  }
}
